import { render, staticRenderFns } from "./computer-time-dialog.vue?vue&type=template&id=c2b5d016&scoped=true&"
import script from "./computer-time-dialog.vue?vue&type=script&lang=js&"
export * from "./computer-time-dialog.vue?vue&type=script&lang=js&"
import style0 from "./computer-time-dialog.vue?vue&type=style&index=0&id=c2b5d016&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b5d016",
  null
  
)

export default component.exports